export default __webpack_public_path__ + "static/media/title_pc.bdc0d940.png";